import { Button } from '@app/src/common/Button';
import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'MyAccount/listAvailable/ModalAvailable';

export const Wrapper = styled.div`
  min-width: 290px;
  min-height: 257px;
  background: #f2f2f2;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK_BOLD};
  border-radius: 16px;
  font-size: 16px;
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

export const Head = styled.div`
  padding: 20px 0 16px;
  border-bottom: 1px solid rgba(0,0,0,.4);
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  position: relative;
`;

Head.displayName = `${ROOT}/Head`;

export const Content = styled.div`
  padding: 15px;
`;

Content.displayName = `${ROOT}/Content`;

export const IconClose = styled.span`
  display: inline-block;
  background: ${COLORS.BLACK_BOLD};
  border-radius: 100%;
  width: 32px;
  height: 32px;
  position: absolute;
  line-height: 32px;
  top: -8px;
  right: -8px;
  cursor: pointer;
`;

IconClose.displayName = `${ROOT}/IconClose`;

export const List = styled.ul`
  padding: 17px 40px 20px;
`;

List.displayName = `${ROOT}/List`;

export const Item = styled.li`
  margin-bottom: 17px;
  display: flex;
`;

Item.displayName = `${ROOT}/Item`;

export const Text = styled.span`
  font-weight: 700;
  color: ${COLORS.BLACK_BOLD};
`;

Text.displayName = `${ROOT}/Text`;

export const Quantity = styled.a`
  font-size: 15px;
  margin-left: auto;
  text-decoration: underline;
`;

Quantity.displayName = `${ROOT}/Quantity`;

export const LinkConsume = styled.a`
  text-decoration: underline;
  color: ${COLORS.BLUE_LINK};
  font-size: 15px;
  margin-left: auto;
`;

LinkConsume.displayName = `${ROOT}/LinkConsume`;

export const Available = styled.a`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 13px;
  border: 1px solid ${COLORS.BLUE_LINK};
  color: ${COLORS.BLUE_LINK};
  border-radius: 6px;
  line-height: 42px;
  padding: 0 15px;
  margin-left: 33px;
`;

Available.displayName = `${ROOT}/Available`;

export const Operation = styled.p`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 17px;
  color: #000;
`;

Operation.displayName = `${ROOT}/Operation`;

export const Newspaper = styled.h3`
  font-size: 16px;
`;

Newspaper.displayName = `${ROOT}/Newspaper`;

export const Description = styled.p`
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  margin-top: 16px;
`;

Description.displayName = `${ROOT}/Description`;

export const Date = styled.span`
  font-size: 16px;
  color: #000;
  display: block;
`;

Date.displayName = `${ROOT}/Date`;

export const Extracharges = styled.ul`
  margin-top: 16px;
`;

Extracharges.displayName = `${ROOT}/Extracharges`;

export const ItemExtra = styled.li`
  font-size: 16px;
  color: #000;
`;

ItemExtra.displayName = `${ROOT}/ItemExtra`;

export const LoaderWrapper = styled.div`
  min-width: 290px;
  min-height: 257px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ActionWrapper = styled.div`
  margin-top: 20px
`;

ActionWrapper.displayName = `${ROOT}/ActionWrapper`;

export const ButtonPublish = styled(Button)`
  margin: 0 auto 8px;
`;

ButtonPublish.displayName = `${ROOT}/ButtonPublish`;

export const ButtonPackage = styled(Button)`
  margin: 0 auto;
`;

ButtonPackage.displayName = `${ROOT}/ButtonPackage`;